import WidgetEntity from '../WidgetEntity';
import * as Widgets from '@mm/constants/widgets';

export default class AudioWidget extends WidgetEntity {
  static make(pageId: number, sortOrder: number) {
    const widget = {
      ...super.make(pageId, Widgets.AUDIO, 'Untitled audio', sortOrder),
      config: {
        title: 'Untitled audio',
        assetId: null,
      },
      title: '',
    };

    // @ts-ignore
    delete widget.title;

    return widget;
  }
}
